import type { FunctionComponent } from 'react';

export const OpenCorporatesIcon: FunctionComponent<{ className?: string }> = ({ className }) => {
  return (
    <img
      src="https://cdn.ballerine.io/merch-ss/decoded_image_2.png"
      alt="OpenCorporates"
      className={className}
    />
  );
};
